import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Suspense } from 'react';
import { Routes } from 'react-router';
import { Route } from 'react-router-dom';
import { publicRoutesList, privateRoutesList, PublicRouteView, PrivateRouteView, facilityRoutesList, } from 'routes';
import { Toast } from './common/Toast';
import { AppFallbackLoader } from 'common/AppFallbackLoader/ApplicationLoader.component';
import './App.css';
import { WCThemeProvider } from 'themes';
import { FacilityLayout, PublicLayout, WCLayout } from 'layouts';
import PageNotFound from 'common/PageNotFound';
import { useAppSelector } from 'hooks/reduxHooks';
import UnauthorizedAccess from 'common/UnauthorizedAccess';
var App = function () {
    var AuthInit = React.lazy(function () { return import('common/AuthInit/AuthInit'); });
    var Dialogs = React.lazy(function () { return import('./common/Dialogs'); });
    var OverlayDialogs = React.lazy(function () { return import('./common/Dialogs/OverlayDialogs.component'); });
    var PusherChannelSubscriber = React.lazy(function () { return import('pusher/PusherChannelSubscriber'); });
    var Events = React.lazy(function () { return import('common/Events/Events'); });
    var isUnauthorized = useAppSelector(function (state) { return state.common.unauthorised.isUnauthorized; });
    if (isUnauthorized) {
        return _jsx(UnauthorizedAccess, {});
    }
    var InternetWatcher = function () {
        React.useEffect(function () {
            var channel = new BroadcastChannel("internet-status");
            var handleOffline = function () {
                console.log("Internet OFFLINE");
                localStorage.setItem("needs-reload", "true");
            };
            var handleOnline = function () {
                console.log("Internet ONLINE (this tab)");
                localStorage.setItem("needs-reload", "false");
                channel.postMessage("online-now");
            };
            // When another tab becomes online
            channel.onmessage = function (msg) {
                if (msg.data === "online-now") {
                    localStorage.setItem("needs-reload", "false");
                }
            };
            var handleVisibility = function () {
                if (document.visibilityState === "visible") {
                    var shouldReload = localStorage.getItem("needs-reload") === "true";
                    if (shouldReload) {
                        localStorage.setItem("needs-reload", "false");
                    }
                }
            };
            window.addEventListener("offline", handleOffline);
            window.addEventListener("online", handleOnline);
            document.addEventListener("visibilitychange", handleVisibility);
            return function () {
                window.removeEventListener("offline", handleOffline);
                window.removeEventListener("online", handleOnline);
                document.removeEventListener("visibilitychange", handleVisibility);
                channel.close();
            };
        }, []);
        return null;
    };
    return (_jsxs(_Fragment, { children: [_jsx(InternetWatcher, {}), _jsxs(Suspense, { fallback: _jsx(AppFallbackLoader, {}), children: [_jsx(AuthInit, {}), _jsx(PusherChannelSubscriber, {}), _jsxs(WCThemeProvider, { children: [_jsx(Toast, {}), _jsx(Dialogs, {}), _jsx(OverlayDialogs, {}), _jsx(Events, {})] }), _jsxs(Routes, { children: [_jsx(Route, { element: _jsx(PublicLayout, {}), children: publicRoutesList.map(function (route) {
                                    return (_jsx(Route, { path: route.path, element: _jsx(PublicRouteView, { component: route.component, meta: route.meta }) }, route.path));
                                }) }), _jsx(Route, { element: _jsx(WCLayout, {}), children: privateRoutesList.map(function (route) {
                                    return (_jsx(Route, { path: route.path, element: _jsx(PrivateRouteView, { component: route.component, meta: route.meta, requiredRoles: route.requiredRoles }) }, route.path));
                                }) }), _jsx(Route, { element: _jsx(FacilityLayout, {}), children: facilityRoutesList.map(function (route) {
                                    return (_jsx(Route, { path: route.path, element: _jsx(PrivateRouteView, { component: route.component, meta: route.meta, requiredRoles: route.requiredRoles }) }, route.path));
                                }) }), _jsx(Route, { path: "*", element: _jsx(PageNotFound, {}) })] })] })] }));
};
var AppPage = App;
export default AppPage;
